<template>
  <form @submit.prevent="submit" class="form" method="post">
    <FormInput :name="$t('meta.name')" v-model="project.name" />

    <FormSimpleSelect
      v-if="companyUser.company.company_type == 'branch'"
      :name="$t('projects.groupContainersBy')"
      :options="groupedByOptions"
      v-model="project.group_containers_by"
    />

    <FormSimpleSelect
      v-if="locations"
      :name="$t('meta.location')"
      :options="locations"
      v-model="project.location_uuid"
    />
    <LoadingSpinner v-else />

    <div>
      <input type="submit" :value="$t('meta.save')" class="button button-green button-100" />
    </div>
  </form>
</template>

<script>
import FormInput from '@/components/Form/Input'
import FormSimpleSelect from '@/components/Form/SimpleSelect'
import LoadingSpinner from '@/components/LoadingSpinner'

import locationsApi from '@/api/locations'

export default {
  props: {
    companyUuid: String,
    initialProject: Object,
  },
  inject: ['companyUser'],
  components: {
    LoadingSpinner,
    FormInput,
    FormSimpleSelect,
  },
  data: function () {
    return {
      project: this.initialProject || {
        name: null,
        group_containers_by: 'address',
        location_uuid: null,
      },
      locations: null,
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.project)
    },
  },
  computed: {
    groupedByOptions() {
      return [
        { name: this.$t('projects.groupContainersByOptions.address'), uuid: 'address' },
        { name: this.$t('projects.groupContainersByOptions.coordinates'), uuid: 'coordinates' },
      ]
    },
    selectedLocation() {
      return this.locations?.find(location => location.uuid === this.project.location_uuid)
    },
  },
  async mounted() {
    this.locations = await locationsApi.getAllForCompany(this.companyUuid)
  },
}
</script>
